import React, { useCallback, useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import ButtonSp from '../../components/ButtonSp';

import InputTextSp from '../../components/InputTextSp';
import LabelSp from '../../components/LabelSp';
import { showMessage } from '../../components/MessageDialog';

import FinBoletoService from '../../services/FinBoletoService';

import { errorHandle, formatDate, formatFloat } from '../../util/functions';
import { BoletoModel } from '../../util/Models';
import { StateScreen } from '../constants';

function BoletoCrud(props) {
  BoletoCrud.propTypes = {
    stateScreen: PropTypes.string.isRequired,
    idSelected: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  BoletoCrud.defaultProps = {
    messageConfirmation: 'Confirma os dados',
    showConfirmation: false,
  };

  const { stateScreen, idSelected, onClose } = props;

  // states
  const [boleto, setBoleto] = useState(new BoletoModel());

  const [errorLoadRecord, setErrorLoadRecord] = useState(false);

  // useCallbacks

  const loadRecord = useCallback(async _id => {
    try {
      const retorno = await FinBoletoService.findById(_id);

      setBoleto(retorno);

      setErrorLoadRecord(false);
    } catch (err) {
      setErrorLoadRecord(true);
      errorHandle(err);
    }
  }, []);

  // funcoes
  function viewMode() {
    return stateScreen === StateScreen.stView || errorLoadRecord;
  }

  function handleBack() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      showMessage('Confirmação', 'Abandonar mudanças?', idx => {
        if (idx === 1) {
          onClose();
        }
      });
    }
  }

  // useEffects
  useEffect(() => {
    if (stateScreen === StateScreen.stUpdate || stateScreen === StateScreen.stView) {
      loadRecord(idSelected);
    } else if (stateScreen === StateScreen.stInsert) {
      const novo = new BoletoModel();

      setBoleto(novo);
    }
  }, [loadRecord, idSelected, stateScreen]);

  // render principal
  return (
    <>
      <>
        <div className="p-col-6 p-sm-2 p-lg-2 p-fluid">
          <LabelSp>Contrato</LabelSp>
          <InputTextSp value={boleto.numeroContrato} disabled={viewMode()} />
        </div>
        <div className="p-col-6 p-sm-2 p-lg-2 p-fluid">
          <LabelSp>CPF/CNPJ</LabelSp>
          <InputTextSp value={boleto.sacadoCpfCnpj} disabled={viewMode()} />
        </div>
        <div className="p-col-6 p-sm-2 p-lg-2 p-fluid">
          <LabelSp>Vencimento</LabelSp>
          <InputTextSp
            autoFocus
            value={formatDate(boleto.vencimento, 'dd/MM/yyyy')}
            disabled={viewMode()}
          />
        </div>
        <div className="p-col-6 p-sm-2 p-lg-2 p-fluid">
          <LabelSp>Valor</LabelSp>
          <InputTextSp
            style={{ textAlign: 'end' }}
            value={formatFloat(boleto.valorDocumento)}
            disabled={viewMode()}
          />
        </div>
        <div className="p-col-6 p-sm-2 p-lg-2 p-fluid">
          <LabelSp>Nosso Número</LabelSp>
          <InputTextSp value={boleto.nossoNumero} required disabled={viewMode()} />
        </div>
        <div className="p-col-6 p-sm-2 p-lg-2 p-fluid">
          <LabelSp>Nr. Documento</LabelSp>
          <InputTextSp value={boleto.numeroDocumento} required disabled={viewMode()} />
        </div>
        <div className="p-col-12 p-sm-6 p-lg-6 p-fluid">
          <LabelSp>Nome</LabelSp>
          <InputTextSp
            autoFocus
            value={boleto.sacadoNome}
            maxLength={100}
            required
            disabled={viewMode()}
          />
        </div>
        <div className="p-col-12 p-sm-6 p-lg-6 p-fluid">
          <LabelSp>Nome Fantasia</LabelSp>
          <InputTextSp
            autoFocus
            value={boleto.sacadoFantasia}
            maxLength={100}
            required
            disabled={viewMode()}
          />
        </div>

        <div className="p-col-12 p-sm-6 p-lg-6 p-fluid">
          <LabelSp>Linha Digitável</LabelSp>
          <InputTextSp value={boleto.linhaDigitavel} disabled={viewMode()} />
        </div>

        <div className="p-col-12 p-sm-6 p-lg-6 p-fluid">
          <LabelSp>Cód. Barras</LabelSp>
          <InputTextSp value={boleto.codigoBarras} disabled={viewMode()} />
        </div>

        <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
          <ButtonSp
            className="p-button-secondary"
            label="Voltar"
            icon="pi pi-chevron-circle-left"
            keyAccess="V"
            onClick={handleBack}
          />
        </div>
      </>
    </>
  );
}

export default BoletoCrud;
